
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'may-schedule-info',
  templateUrl: './may-schedule-info.component.html',
  styleUrls: ['./may-schedule-info.component.sass']

})

export class MayScheduleInfo implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}
